import { usePostRule } from "hooks/rules/usePostRule";
import PropTypes from "prop-types";
import React from "react";
import {
  RuleDialog,
  RuleFormValues
} from "components/rules-management/RuleDialog/RuleDialog";
import { Tag } from "interfaces/tag";

export interface CreateRuleDialogProps {
  open: boolean;
  loadingTags: boolean;
  tags: Tag[];
  onClose: () => void;
  onSuccess: (ruleId: number) => void;
}

export const CreateRuleDialog = ({
  open,
  loadingTags,
  tags,
  onClose = () => {},
  onSuccess = () => {}
}: CreateRuleDialogProps): JSX.Element => {
  const { loading, error, postRuleCallback } = usePostRule();

  const handleSubmit = ({
    ruleName,
    tag,
    hysteresisPoints
  }: RuleFormValues): void => {
    const tempRule = {
      name: ruleName,
      tag: tag?.id,
      hysteresis_points: parseInt(hysteresisPoints),
      enabled: true
    };

    //@ts-ignore
    postRuleCallback(tempRule).then(
      rule => {
        onSuccess(rule.id);
      },
      _failure => {}
    );
  };

  return (
    <RuleDialog
      open={open}
      loading={loading || loadingTags}
      title="Create new rule"
      initialValues={{
        ruleName: "",
        tag: null,
        hysteresisPoints: "3"
      }}
      error={error}
      errorText="An error occurred while trying to update the rule"
      tags={tags}
      confirmText="Create rule"
      onSubmit={handleSubmit}
      onClose={onClose}
      aria-label="create rule dialog"
    />
  );
};

CreateRuleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  loadingTags: PropTypes.bool.isRequired,
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func
};
